import { ReactComponent as ArrowDown } from "../../img/arrow-empt.svg";
import styles from "./styles.module.scss";
import { HTMLAttributes } from "react";

export type DownArrowType = HTMLAttributes<HTMLDivElement> & {
  dark: boolean
};

const DownArrow = ({ className, dark, ...props }: DownArrowType) => {
  return (
    <span
      className={`${styles.downArrow} ${dark == true ? styles.dark : ""} ${className ?? ""}`}
      {...props}
    >
      <ArrowDown />
    </span>
  )
};

export default DownArrow;